
























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import SuporteProcedimentosApenasHospitalDiaStore from '@/components/Suporte/Store/SuporteProcedimentosApenasHospitalDiaStore'
import { DataTablePagination } from '@/types/_'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteProcedimentosApenasHospitalDia extends Vue {
  loadProcedimentosApenasHospitalDia: boolean = false
  loadAddProcedimentoApenasHospitalDia: boolean = false
  loadEditProcedimentoApenasHospitalDia: string = ''

  get getSuporteProcedimentosApenasHospitalDiaStore() {
    return getModule(SuporteProcedimentosApenasHospitalDiaStore, this.$store)
  }

  get paginationProcedimentosApenasHospitalDia() { return this.getSuporteProcedimentosApenasHospitalDiaStore.paginationProcedimentosApenasHospitalDia }

  get loadingProcedimentosApenasHospitalDia() { return this.loadProcedimentosApenasHospitalDia }
  set loadingProcedimentosApenasHospitalDia(value: boolean) { this.loadProcedimentosApenasHospitalDia = value }
  get loadingAddProcedimentoApenasHospitalDia() { return this.loadAddProcedimentoApenasHospitalDia }
  set loadingAddProcedimentoApenasHospitalDia(value: boolean) { this.loadAddProcedimentoApenasHospitalDia = value }
  get loadingEditProcedimentoApenasHospitalDia() { return this.loadEditProcedimentoApenasHospitalDia }
  set loadingEditProcedimentoApenasHospitalDia(value: string) { this.loadEditProcedimentoApenasHospitalDia = value }

  get hospitalId() { return this.getSuporteProcedimentosApenasHospitalDiaStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteProcedimentosApenasHospitalDiaStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get procedimentosApenasHospitalDiaHeaders() {
    return [
      { text: 'Procedimento', value: 'procedimentoDescricao', sortable: false },
      { text: 'Código', value: 'codigo', sortable: false },
      { text: 'Convênio', value: 'convenioDescricao', sortable: false },
      { text: 'Hospital Dia', value: 'hospitalDia', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get procedimentosApenasHospitalDia() { return this.getSuporteProcedimentosApenasHospitalDiaStore.procedimentosApenasHospitalDia }
  get searchProcedimentoApenasHospitalDia() { return this.getSuporteProcedimentosApenasHospitalDiaStore.searchProcedimentoApenasHospitalDia }
  set searchProcedimentoApenasHospitalDia(value: string) { this.getSuporteProcedimentosApenasHospitalDiaStore.setSearchProcedimentoApenasHospitalDia(value) }

  @Watch('searchProcedimentoApenasHospitalDia')
  async onChangeSearchProcedimentoApenasHospitalDia(value: any) {
    this.procedimentosApenasHospitalDiaPagedDebounce({ ...this.paginationProcedimentosApenasHospitalDia })
  }

  async hospitalChange(id: any) {
    this.getSuporteProcedimentosApenasHospitalDiaStore.setSearchProcedimentoApenasHospitalDia('')
    this.getSuporteProcedimentosApenasHospitalDiaStore.setHospitalId(id)

    const params: any = { hospitalId: id }

    this.loadingProcedimentosApenasHospitalDia = true
    await this.getSuporteProcedimentosApenasHospitalDiaStore.getProcedimentosApenasHospitalDiaPagedSearch({
      ...params,
      ...this.getSuporteProcedimentosApenasHospitalDiaStore.procedimentosApenasHospitalDiaPaginationDefault,
    })
    this.loadingProcedimentosApenasHospitalDia = false
  }

  procedimentosApenasHospitalDiaPagedDebounce = _.debounce(param => this.getSuporteProcedimentosApenasHospitalDiaStore.getProcedimentosApenasHospitalDiaPagedSearch(param), 700)

  async updatePaginationProcedimentosApenasHospitalDia(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingProcedimentosApenasHospitalDia = true
    this.procedimentosApenasHospitalDiaPagedDebounce(pagination)
    this.loadingProcedimentosApenasHospitalDia = false
  }

  async adicionarProcedimentoApenasHospitalDia() {
    this.loadingAddProcedimentoApenasHospitalDia = true
    this.getSuporteProcedimentosApenasHospitalDiaStore.setMode({ modal: 'procedimentoApenasHospitalDia', mode: 'CREATE' })
    this.getSuporteProcedimentosApenasHospitalDiaStore.clearProcedimentoApenasHospitalDia()

    const requestProcedimentos = await this.getSuporteProcedimentosApenasHospitalDiaStore.getProcedimentos()
    if (!requestProcedimentos.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${requestProcedimentos.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadAddProcedimentoApenasHospitalDia = false
      return
    }

    const requestConvenios = await this.getSuporteProcedimentosApenasHospitalDiaStore.getConvenios()
    if (!requestConvenios.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${requestConvenios.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadAddProcedimentoApenasHospitalDia = false
      return
    }

    this.getSuporteProcedimentosApenasHospitalDiaStore.setModal({ name: 'procedimentoApenasHospitalDia', value: true })
    this.loadingAddProcedimentoApenasHospitalDia = false
  }

  async editarProcedimentoApenasHospitalDia(item: any) {
    this.loadingEditProcedimentoApenasHospitalDia = item.procedimentoId
    this.getSuporteProcedimentosApenasHospitalDiaStore.setMode({ modal: 'procedimentoApenasHospitalDia', mode: 'EDIT' })

    const requestProcedimentos = await this.getSuporteProcedimentosApenasHospitalDiaStore.getProcedimentos()
    if (!requestProcedimentos.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${requestProcedimentos.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingEditProcedimentoApenasHospitalDia = ''
      return
    }

    const requestConvenios = await this.getSuporteProcedimentosApenasHospitalDiaStore.getConvenios()
    if (!requestConvenios.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${requestConvenios.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingEditProcedimentoApenasHospitalDia = ''
      return
    }

    this.getSuporteProcedimentosApenasHospitalDiaStore.setProcedimentoApenasHospitalDia({ ...item })
    this.getSuporteProcedimentosApenasHospitalDiaStore.setModal({ name: 'procedimentoApenasHospitalDia', value: true })
    this.loadingEditProcedimentoApenasHospitalDia = ''
  }

  beforeDestroy() {
    this.getSuporteProcedimentosApenasHospitalDiaStore.clearProcedimentosApenasHospitalDia()
    this.getSuporteProcedimentosApenasHospitalDiaStore.clearProcedimentos()
    this.getSuporteProcedimentosApenasHospitalDiaStore.clearConvenios()
    this.getSuporteProcedimentosApenasHospitalDiaStore.clearHospitalId()
  }
}
